import { ApprovalStatus, ContributorStatus, OfferStatus, RoleInOffer } from '..'

export const offerActionGroupPolicyType = {
  ACTION_SAVE: 'ACTION_SAVE',
  ACTION_SUBMIT_QUOTATION: 'ACTION_SUBMIT_QUOTATION',
  ACTION_RESUBMIT_QUOTATION: 'ACTION_RESUBMIT_QUOTATION',
  ACTION_SUBMIT_BOOKING: 'ACTION_SUBMIT_BOOKING',
  ACTION_RESUBMIT_BOOKING: 'ACTION_RESUBMIT_BOOKING',
  ACTION_REVIEW_CONTRIBUTION: 'ACTION_REVIEW_CONTRIBUTION',
  ACTION_COMMENT_CONTRIBUTION: 'ACTION_COMMENT_CONTRIBUTION',
  ACTION_REVIEW_OPTIONAL_CONTRIBUTION: 'ACTION_REVIEW_OPTIONAL_CONTRIBUTION',
  ACTION_QUOTATION_APPROVAL: 'ACTION_QUOTATION_APPROVAL',
  ACTION_BOOKING_APPROVAL: 'ACTION_BOOKING_APPROVAL',
  ACTION_BOOKING_APPROVAL_INVITATION: 'ACTION_BOOKING_APPROVAL_INVITATION',
  ACTION_REPLY_QUOTATION_INVITATION: 'ACTION_REPLY_QUOTATION_INVITATION',
  ACTION_REPLY_BOOKING_INVITATION: 'ACTION_REPLY_BOOKING_INVITATION',
  ACTION_REPLY_GCPR_INVITATION: 'ACTION_REPLY_GCPR_INVITATION',
  ACTION_PR_APPROVAL: 'ACTION_PR_APPROVAL',
}

const isSalesSide = (role) => {
  return [RoleInOffer.CREATOR, RoleInOffer.INITIATOR, RoleInOffer.DEPT_USER].includes(role)
}

const isCoreContributor = (role) => {
  return [
    RoleInOffer.COMMERCIAL_PROJECT_MANAGER,
    RoleInOffer.TECHNICAL_PROJECT_MANAGER,
    RoleInOffer.CONTRIBUTOR_LEGAL,
    RoleInOffer.CONTRIBUTOR_QS,
    RoleInOffer.CONTRIBUTOR_OTHER,
  ].includes(role)
}

export const offerActionGroupPolicies = {
  [offerActionGroupPolicyType.ACTION_SAVE]: {
    view: true,
    edit: ({ role, isFreeze = false }) => {
      return !isFreeze && role !== ''
    },
  },
  [offerActionGroupPolicyType.ACTION_SUBMIT_QUOTATION]: {
    view: true,
    edit: ({ role, offerStatus }) => isSalesSide(role) && offerStatus === OfferStatus.QUOTATION_DRAFT,
  },
  [offerActionGroupPolicyType.ACTION_RESUBMIT_QUOTATION]: {
    view: true,
    edit: ({ role, offerStatus }) => isSalesSide(role) && offerStatus === OfferStatus.QUOTATION_REJECTED,
  },
  [offerActionGroupPolicyType.ACTION_SUBMIT_BOOKING]: {
    view: true,
    edit: ({ role, offerStatus }) => isSalesSide(role) && offerStatus === OfferStatus.BOOKING_DRAFT,
  },
  [offerActionGroupPolicyType.ACTION_RESUBMIT_BOOKING]: {
    view: true,
    edit: ({ role, offerStatus }) => isSalesSide(role) && offerStatus === OfferStatus.BOOKING_REJECTED,
  },
  [offerActionGroupPolicyType.ACTION_REVIEW_CONTRIBUTION]: {
    view: true,
    edit: ({ role, offerStatus, allRoleDetails }) => {
      const roleDetail = allRoleDetails.find((roleDetail) => isCoreContributor(roleDetail.role))?.roleDetail

      console.log('roleDetail', roleDetail)

      return (
        roleDetail &&
        [ContributorStatus.REQUIRED, ContributorStatus.COMMENTED].includes(roleDetail?.status) &&
        [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_SUBMITTED, OfferStatus.QUOTATION_REJECTED].includes(
          offerStatus
        )
      )
    },
  },
  [offerActionGroupPolicyType.ACTION_COMMENT_CONTRIBUTION]: {
    view: true,
    edit: ({ role, offerStatus, allRoles, allRoleDetails }) => {
      const roleDetail = allRoleDetails.find((roleDetail) => isCoreContributor(roleDetail.role))?.roleDetail

      return (
        roleDetail &&
        roleDetail?.status === ContributorStatus.REQUIRED &&
        [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_SUBMITTED, OfferStatus.QUOTATION_REJECTED].includes(
          offerStatus
        )
      )
    },
  },
  [offerActionGroupPolicyType.ACTION_REVIEW_OPTIONAL_CONTRIBUTION]: {
    view: true,
    edit: ({ role, offerStatus, allRoleDetails }) => {
      const roleDetail = allRoleDetails.find(
        (roleDetail) => roleDetail.role === RoleInOffer.OPTIONAL_CONTRIBUTOR
      )?.roleDetail

      return (
        roleDetail &&
        roleDetail?.status !== ContributorStatus.REVIEWED &&
        [OfferStatus.QUOTATION_DRAFT, OfferStatus.QUOTATION_SUBMITTED, OfferStatus.QUOTATION_REJECTED].includes(
          offerStatus
        )
      )
    },
  },
  [offerActionGroupPolicyType.ACTION_QUOTATION_APPROVAL]: {
    view: true,
    edit: ({ role, offerStatus, roleDetail }) =>
      [RoleInOffer.QUOTATION_APPROVER, RoleInOffer.QUOTATION_APPROVER_DELEGATEE].includes(role) &&
      roleDetail?.status === ApprovalStatus.REQUIRED &&
      offerStatus === OfferStatus.QUOTATION_REVIEWED,
  },
  [offerActionGroupPolicyType.ACTION_BOOKING_APPROVAL]: {
    view: true,
    edit: ({ role, offerStatus, roleDetail, allRoles }) => {
      const isNormalBookingApprover =
        [
          RoleInOffer.BOOKING_APPROVER,
          RoleInOffer.BOOKING_COMMERCIAL_PROJECT_MANAGER,
          RoleInOffer.BOOKING_APPROVER_DELEGATEE,
        ].includes(role) &&
        roleDetail?.status === ApprovalStatus.REQUIRED &&
        offerStatus === OfferStatus.BOOKING_SUBMITTED

      // const isPRApprover = allRoles.includes(RoleInOffer.PR_APPROVER)
      return isNormalBookingApprover
    },
  },
  [offerActionGroupPolicyType.ACTION_BOOKING_APPROVAL_INVITATION]: {
    view: true,
    edit: ({ role, offerStatus, roleDetail }) => {
      return (
        [
          RoleInOffer.BOOKING_APPROVER,
          RoleInOffer.BOOKING_COMMERCIAL_PROJECT_MANAGER,
          RoleInOffer.BOOKING_APPROVER_DELEGATEE,
        ].includes(role) &&
        roleDetail?.status === ApprovalStatus.REQUIRED &&
        offerStatus === OfferStatus.BOOKING_SUBMITTED
      )
    },
  },

  [offerActionGroupPolicyType.ACTION_REPLY_QUOTATION_INVITATION]: {
    view: true,
    edit: ({ allRoles, offerStatus, roleDetail }) =>
      allRoles.some((role) => role === RoleInOffer.QUOTATION_APPROVER_INVITEE) &&
      roleDetail?.status !== 'Replied' &&
      roleDetail?.status !== '',
  },
  [offerActionGroupPolicyType.ACTION_REPLY_BOOKING_INVITATION]: {
    view: true,
    edit: ({ allRoles, offerStatus, roleDetail }) =>
      allRoles.some((role) => role === RoleInOffer.BOOKING_APPROVER_INVITEE) &&
      roleDetail?.status !== 'Replied' &&
      roleDetail?.status !== '',
  },
  [offerActionGroupPolicyType.ACTION_REPLY_GCPR_INVITATION]: {
    view: true,
    edit: ({ allRoles, roleDetail }) =>
      allRoles.some((role) => role === RoleInOffer.GCPR_APPROVER_INVITEE) &&
      roleDetail?.status !== 'Replied' &&
      roleDetail?.status !== '',
  },
}
